import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[ngc-KeyboardFocus]'
})
export class KeyboardFocusDirective {
  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event']) onKeydownHandler(event) {
    // event for flexible date on tabs
    const flexDatesKeyFocus = this.el.nativeElement.classList.contains(
      'flexDatesPrCalendar'
    );
    if (
      flexDatesKeyFocus &&
      event.target.hasAttribute('role') &&
      event.target.getAttribute('role') === 'tab'
    ) {
      if (event.keyCode === 39) {
        // right arrow
        event.preventDefault();
        if (event.target.nextElementSibling != null) {
          event.target.nextElementSibling.focus();
        }
      } else if (event.keyCode === 37) {
        // left arrow
        event.preventDefault();
        if (event.target.previousElementSibling != null) {
          event.target.previousElementSibling.focus();
        }
      }
    }
    // etect event for primary nav
    if (event.target.parentElement.classList.contains('app-link-item')) {
      if (
        (event.keyCode === 39 || event.keyCode === 40) &&
        document.body.clientWidth > 991
      ) {
        // right arrow & down arrow
        event.preventDefault();
        if (event.target.parentElement.nextElementSibling != null) {
          event.target.parentElement.nextElementSibling.firstChild.focus();
          event.target.parentElement.nextElementSibling.firstChild.click();
        }
      } else if (
        (event.keyCode === 37 || event.keyCode === 38) &&
        document.body.clientWidth > 991
      ) {
        // left arrow & up arrow
        event.preventDefault();
        const prevElm = event.target.parentElement.previousElementSibling;
        if (event.target.classList.contains('nav-link-book')) {
          this.el.nativeElement.querySelector('.last-static-link a').focus();
          this.el.nativeElement.querySelector('.last-static-link a').click();
        } else if (prevElm != null) {
          prevElm.firstChild.focus();
          prevElm.firstChild.click();
        }
      } else if (
        event.target.parentElement.classList.contains('active-menu') &&
        event.keyCode === 9 &&
        event.shiftKey
      ) {
        return true;
      } else if (
        event.target.parentElement.classList.contains('active-menu') &&
        event.keyCode === 9
      ) {
        // tab key  event for active menu
        const firstfocusElement =
          this.el.nativeElement.querySelector('.focusable-element');
        if (firstfocusElement && firstfocusElement.clientWidth !== 0) {
          event.preventDefault();
          firstfocusElement.focus();
          event.preventDefault();
        }
      }
    } else if (
      event.target.classList.contains('last-focusable-element') &&
      document.body.clientWidth > 991
    ) {
      // on button tab, focus moved to next element to active menu.
      if (event.shiftKey && event.keyCode === 9) {
        // this blank condition for Shift + Tab
      } else if (event.keyCode === 9) {
        const lastfocusElement =
          this.el.nativeElement.querySelector('.sign-up');
        const lastfocusElementlogin =
          this.el.nativeElement.querySelector('.logged-in-flyout');
        if (lastfocusElement) {
          // event.preventDefault();
          lastfocusElement.focus();
          event.preventDefault();
        } else {
          lastfocusElementlogin.focus();
          event.preventDefault();
        }
      }
    } else if (event.target.classList.contains('focusable-element')) {
      // shift tab event on first element of widget
      if (event.shiftKey === true && event.keyCode === 9) {
        const focusElement = this.el.nativeElement
          .querySelector('.nav-primary')
          .querySelector(':not(.d-lg-none).active-menu').firstChild;
        if (focusElement) {
          // event.preventDefault();
          focusElement.focus();
          event.preventDefault();
        }
      }
    } else if (
      event.target.classList.contains('icon-search-icon') &&
      document.body.clientWidth > 991
    ) {
      if (event.shiftKey !== true && event.keyCode === 9) {
        if (document.querySelector('#contentFragment')) {
          // homepage
          const heroFocuselm = document.querySelectorAll(
            '#contentFragment a'
          )[0] as HTMLElement;
          heroFocuselm.focus();
          event.preventDefault();
        } else if (document.querySelector('#LayoutContainer')) {
          // bauapplications
          const bauFocuselm = document.querySelectorAll(
            '#LayoutContainer a'
          )[0] as HTMLElement;
          bauFocuselm.focus();
          event.preventDefault();
        } else if (document.querySelector('.redeem-documents-view')) {
          // edocs
          const edocFocuselm = document.querySelectorAll(
            '.redeem-documents-view a'
          )[0] as HTMLElement;
          edocFocuselm.focus();
          event.preventDefault();
        } else if (document.querySelector('.flifo')) {
          // flifo
          const flifoFocuselm = document.querySelectorAll(
            '.flifo a'
          )[0] as HTMLElement;
          flifoFocuselm.focus();
          event.preventDefault();
        } else if (document.querySelector('.inspire-sub-nav')) {
          // staticpages
          const flifoFocuselm = document.querySelectorAll(
            '.inspire-sub-nav a'
          )[0] as HTMLElement;
          flifoFocuselm.focus();
          event.preventDefault();
        } else if (document.querySelector('.info-sub-nav')) {
          // staticpages
          const flifoFocuselm = document.querySelectorAll(
            '.info-sub-nav a'
          )[0] as HTMLElement;
          flifoFocuselm.focus();
          event.preventDefault();
        } else if (
          document.querySelectorAll('.idp-header__medallion').length > 0
        ) {
          // Profile page
          const profileFocuselm = document.querySelectorAll(
            '.idp-header__medallion a'
          )[0] as HTMLElement;
          profileFocuselm.focus();
          event.preventDefault();
        }
      }
    }
  }
}
